import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import {
  disableBodyScroll,
  clearAllBodyScrollLocks
} from "body-scroll-lock";
import { debounceTime, Subscription } from 'rxjs';
import { SpinnerService } from './spinner.service';

@Component({
  selector: 'app-spinner',
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  standalone: true
})
export class SpinnerComponent implements AfterViewInit, OnDestroy{
  debounceTime: number = 200;
  loading: boolean = false;
  loadingSubscription!: Subscription;

  @ViewChild("scrollTarget") scrollTarget?: ElementRef ;

  constructor(
    private spinnerSrv: SpinnerService,
    private _elmRef: ElementRef,
    private _changeDetectorRef: ChangeDetectorRef
  ){}


    ngAfterViewInit(): void {
      this._elmRef.nativeElement.style.display = 'none';
      this.loadingSubscription = this.spinnerSrv.loadingStatus.pipe(debounceTime(this.debounceTime)).subscribe(
        (status:boolean) => {
          if(status){
            disableBodyScroll(this.scrollTarget?.nativeElement);
          
          }
          else {
            clearAllBodyScrollLocks();

          }
          this._elmRef.nativeElement.style.display = status? 'block' : 'none';
          this._changeDetectorRef.detectChanges();
        }
      )
  }

  ngOnDestroy(): void {
    this.loadingSubscription.unsubscribe()
  }
}


